var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 14A6 6 0 1 1 8 2a6 6 0 1 1 0 12m9.709 2.298-3.396-3.396A7.96 7.96 0 0 0 16 8a8 8 0 1 0-8 8 7.96 7.96 0 0 0 4.898-1.684l3.396 3.397c.381.38 1.021.386 1.411-.004a.996.996 0 0 0 .004-1.41",
  clipRule: "evenodd"
})));
export default SvgSearch;